import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import {
  ELEMENT_ROOT,
  ReturnRoot,
  InsertConversationLog
} from '../store/chatmessage/actions';

import { useChatData } from './util/useChatData';

const SelectBtn = styled.div<{ color: string }>`
	width: 30%;
	padding: 5px;
	font-size: 13px;
	margin: 10px 0;
	cursor: pointer;
	text-align: center;
	color: #fff;
	background: ${props => props.color};
	border: 1px solid ${props => props.color};
	border-radius: 5px;
	transition: 0.3s ease-out;

	&:hover {
		background transparent;
		color: ${props => props.color};
	}
`;

interface IProps {
  color: string;
}

const ReturnBtn: React.FC<IProps> = ({ color }) => {
  const dispatch = useDispatch();
  const { rootNode } = useChatData();
  const InsertLogAndReturnRoot = () => {
    dispatch(InsertConversationLog(ELEMENT_ROOT));
    dispatch(ReturnRoot(rootNode));
  };
  return (
    <SelectBtn
      color={color}
      onClick={() => InsertLogAndReturnRoot()}
      data-testid="return-btn"
    >
      戻る
    </SelectBtn>
  );
};

export default ReturnBtn;
